import request from '@/utils/request'

/**
 * 获取书籍详情
 * @param {Number|String} bookId 书籍ID
 * @return {Promise<any>}
 */

export function getBookDetail(bookId) {
  return request({
    url: '/studentEnd/getBookDetail',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },

    // responseType: 'text',
    data: {
      bookId,
    },
  })
}

/**
 * 获取书籍详情
 * @param {String} isbn
 * @return {Promise<any>}
 */
export function getBwBookDetail(isbn) {
  return request({
    url: '/studentEnd/bw/getBookInfo',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },

    // responseType: 'text',
    data: {
      isbn,
    },
  })
}

/**
 * @param {String} isbn
 * @param {String} imgHref
 */
export function getBwBookCoverImg(isbn, imgHref) {
  return request({
    url: '/studentEnd/bw/getBookImg',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },

    // responseType: 'text',
    data: {
      isbn,
      imgHref,
    },
  })
}

/**
 * 获取教材列表
 * @param {Object} params 参数
 * @param {String} [params.keyword=''] 关键字
 * @param {Number} [params.pageNum=1] 页码
 * @param {Number} [params.pageSize=1000] 每页数量
 * @return {Promise<any>}
 */
export function getBookList({ keyword = '', pageNum = 1, pageSize = 1000 }) {
  return request({
    url: '/studentEnd/getBookList',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    data: {
      keyword,
      pageNum,
      pageSize,
    },
  })
}

/**
 * 获取教师教材列表
 * @param {Object} params 参数
 * @param {String} [params.keyword=''] 关键字
 * @param {Number} [params.pageNum=1] 页码
 * @param {Number} [params.pageSize=1000] 每页数量
 * @return {Promise<any>}
 */
export function getTeacherBookList({ keyword = '', pageNum = 1, pageSize = 1000 }) {
  return request({
    baseURL: '/teacher/api/',
    url: '/teacherEnd/getBookList',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    data: {
      keyword,
      pageNum,
      pageSize,
    },
  })
}

/**
 * 获取lti教材列表
 * @param {Object} params 参数
 * @param {String} [params.keyword=''] 关键字
 * @param {Number} [params.pageNum=1] 页码
 * @param {Number} [params.pageSize=1000] 每页数量
 * @param {String} [params.courseCode=''] 课程代码
 * @param {String} [params.schoolYear=''] 学年
 * @param {String} [params.termName=''] 学期
 * @return {Promise<any>}
 */
export function getLtiBookList({
  keyword = '',
  courseCode = '',
  schoolYear = '',
  termName = '',
  pageNum = 1,
  pageSize = 1000,
}) {
  return request({
    baseURL: '/lti/api/',
    url: '/lti/getBookList',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    data: {
      keyword,
      courseCode,
      yearName: schoolYear,
      termName,
      pageNum,
      pageSize,
    },
  })
}

/**
 * 从内容服务器获取教材列表
 * @param {String} isbns isbns
 * @return {Promise<any>}
 */

export function getBwBookList(isbns) {
  return request({
    url: '/studentEnd/bw/getBookList',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    data: {
      isbns,
    },
  })
}

/**
 * 获取阅读明细信息
 * @return {Promise<any>}
 */

export function getBookReadDetail() {
  return request({
    url: '/studentEnd/getBookReadDetail',
    method: 'post',
  })
}

/**
 * 获取阅读历史记录
 * @param {Object} params 参数
 * @param {Number} [params.bookId] 书籍ID
 * @param {Number} [params.readId] 阅读历史ID
 * @param {Number} [params.remark] 备注
 * @param {'0'|'1'|'2'|'3'} [params.sort='0'] 排序：0-更新时间倒序,1-更新时间正序,2-创建时间倒序,3-创建时间正序
 * @param {Number} [params.pageNum=1] 页码
 * @param {Number} [params.pageSize=1000] 每页数量
 * @return {Promise<any>}
 */

export function getBookReadHistory({ pageNum = 1, pageSize = 1000, bookId, readId, remark, sort = '0' }) {
  return request({
    url: '/studentEnd/getBookReadList',
    method: 'post',
    data: {
      pageNum,
      pageSize,
      bookId,
      readId,
      remark,
      sort,
    },
  })
}

/**
 * 获取阅读历史记录
 * @param {String} readId 阅读历史ID
 * @return {Promise<any>}
 */

export function deleteBookRead(readId) {
  return request({
    url: '/studentEnd/deleteBookRead',
    method: 'post',
    data: {
      readId,
    },
  })
}

/**
 * 获取课程信息
 * @param {String} courseId 课程ID
 * @return {Promise<any>}
 */

export function getCourseInfo(courseId) {
  return request({
    url: '/studentEnd/getCourseInfo',
    method: 'post',
    data: {
      courseId,
    },
  })
}

/**
 * 获取课程列表
 * @param {Object} params 参数
 * @param {String} [params.courseName] courseName
 * @param {Number} [params.pageNum=1] 页码
 * @param {Number} [params.pageSize=1000] 每页数量
 * @return {Promise<any>}
 */

export function getCourseList({ courseName, pageNum = 1, pageSize = 1000 }) {
  return request({
    url: '/studentEnd/getCourseList',
    method: 'post',
    data: {
      courseName,
      pageNum,
      pageSize,
    },
  })
}

/**
 * 获取课获取我的课程列表
 * @param {Object} params 参数
 * @param {String} [params.courseName] courseName
 * @param {Number} [params.pageNum=1] 页码
 * @param {Number} [params.pageSize=1000] 每页数量
 * @return {Promise<any>}
 */

export function getMyCourseList({ courseName, pageNum = 1, pageSize = 1000 }) {
  return request({

    url: '/studentEnd/getMyCourseList',
    method: 'post',
    data: {
      courseName,
      pageNum,
      pageSize,
    },
  })
}

/**
 * 书籍搜索
 * @param {Object} params 参数
 * @param {String} [params.bookType='1'] 书籍类型 0:纸质书 ; 1 cambook电子书; 2 非cambook电子书
 * @param {String} [params.isbn] 书籍isbn
 * @param {String} [params.keyword=''] 关键字
 * @param {Number} [params.pageNum=1] 页码
 * @param {Number} [params.pageSize=1000] 每页数量
 * @param {String} [params.saleStatus='1'] 上下架状态 0：下架，1：上架
 * @param {String} [params.sort='0'] 排序类型 0-创建时间正序,1-创建时间倒序,2-标题正序,3-标题倒序
 * @param {String} [params.title='']
 * @return {Promise<any>}
 */
export function searchBook({
  bookType = '1',
  isbn,
  keyword,
  pageNum = 1,
  pageSize = 1000,
  saleStatus = '1',
  sort = '0',
  title = '',
}) {
  return request({
    url: '/studentEnd/searchBook',
    method: 'post',
    data: {
      bookType,
      isbn,
      keyword,
      pageNum,
      pageSize,
      saleStatus,
      sort,
      title,
    },
  })
}

/**
 * 书籍下载（待修改）
 * @param {String} bookId 书籍ID
 * @return {Promise<any>}
 */

export function downloadBook(bookId) {
  return request({
    url: '/studentEnd/downloadBook',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    data: {
      bookId,
    },
  })
}

/**
 * 通过ISBN获取书籍详情
 * @param {String} isbn 书籍ID
 * @return {Promise<any>}
 */

export function getBookDetailByIsbn(isbn) {
  return request({
    url: '/studentEnd/getBookDetailByIsbn',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    data: {
      isbn,
    },
  })
}

/**
 * 通过ISBN获取获取教材到期状态
 * @param {String} isbn 书籍ID
 * @return {Promise<any>}
 */

export function getBookExpirationStatusByIsbn(isbn) {
  return request({
    url: '/studentEnd/getBookExpirationStatusByIsbn',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    data: {
      isbn,
    },
  })
}

/**
 * 获取导出书籍标记
 * @param {String} bookId 书籍ID
 * @return {Promise<any>}
 */

export function exportBookHighLight(bookId) {
  return request({
    url: '/studentEnd/exportBookHighLight',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    responseType: 'blob',
    data: {
      bookId,
    },
  })
}

/**
 * 查询学生书籍阅读进度列表
 * @param {Object} params 参数
 * @param {String} [params.keyword] 关键字
 * @param {String} [params.courseId] 课程ID
 * @param {String} [params.yearId] 学年ID
 * @param {String} [params.termId] 学期ID
 * @param {String} [params.bookId] 书籍ID
 * @param {Number} [params.sort] 排序：0-进度正序,1-进度倒序
 * @param {Number} [params.pageNum] 页码
 * @param {Number} [params.pageSize] 每页数量
 * @return {Promise<any>}
 */

export function getStudentBookReadList({ keyword, courseId, yearId, termId, bookId, sort = 0, pageNum = 1, pageSize = 1000 }) {
  return request({
    baseURL: '/teacher/api/',
    url: '/teacherEnd/getStudentBookReadList',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    data: {
      keyword,
      courseId,
      yearId,
      termId,
      bookId,
      sort,
      pageNum,
      pageSize,
    },
  })
}

/**
 * 导出学生书籍阅读进度列表
 * @param {Object} params 参数
 * @param {String} [params.keyword] 关键字
 * @param {String} [params.courseId] 课程ID
 * @param {String} [params.yearId] 学年ID
 * @param {String} [params.termId] 学期ID
 * @param {String} [params.bookId] 书籍ID
 * @param {Number} [params.sort] 排序：0-进度正序,1-进度倒序
 * @param {Number} [params.pageNum] 页码
 * @param {Number} [params.pageSize] 每页数量
 * @return {Promise<any> }
 */

export function exportStudentBookReadList({ keyword, courseId, yearId, termId, bookId, sort = 0, pageNum = 1, pageSize = 1000 }) {
  return request({
    url: '/teacherEnd/exportStudentBookReadList',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    data: {
      keyword,
      courseId,
      yearId,
      termId,
      bookId,
      sort,
      pageNum,
      pageSize,
    },
  })
}
